import { EmailValidator } from 'commons-validator-js'

const emailValidator = new EmailValidator()

export type ValidateEmailReturn = 'invalidEmail' | undefined

// Taken from here https://github.com/wix-private/site-settings-manager/blob/d092e08d4823a3fea93385f2b27c5c4c62860cab/business-info/business-info-client/src/services/email-validator.ts
export const validateEmail = (email?: string): ValidateEmailReturn => {
  if (email && !emailValidator.isValid(email)) {
    return 'invalidEmail'
  }
}
